import { type TimelineDate, TimelineDateFormat } from '@editor2/types/pageElements';

export const timelineDateToDate = (date: TimelineDate) => {
	const dateObj = {
		year: date.year || 0,
		month: date.month - 1 || 0,
		day: date.day || 1,
		hour: date.hour || 0,
		minute: date.minute || 0,
		second: date.second || 0
	};

	const newDate = new Date(
		dateObj.year,
		dateObj.month,
		dateObj.day,
		dateObj.hour,
		dateObj.minute,
		dateObj.second
	);

	return newDate;
};

export const updateTimelineDate = (date: Date, format: TimelineDateFormat) => {
	switch (format) {
		case TimelineDateFormat['Full date and time']:
			return {
				year: date.getFullYear(),
				month: date.getMonth() + 1,
				day: date.getDate(),
				hour: date.getHours(),
				minute: date.getMinutes(),
				second: date.getSeconds()
			};

		case TimelineDateFormat['Full date']:
			return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };

		case TimelineDateFormat['Year and month']:
			return { year: date.getFullYear(), month: date.getMonth() + 1 };

		case TimelineDateFormat.Year:
			return { year: date.getFullYear() };

		default:
			return {};
	}
};
